module.exports = __webpack_public_path__ + "static/media/sites.1a61ab62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/sites.svg
// module id = 255
// module chunks = 0